import React from 'react';
import { Tooltip } from 'antd';
import PropTypes from 'prop-types';
import '../../assets/scss/index.scss';

const CustomTooltip = ({
  title,
  children,
  className = '',
  placement = 'top',
  visible,
}) => {
  return (
    <Tooltip
      title={title}
      placement={placement}
      overlayClassName={`bookroad-tooltip ${className}`}
      open={visible}
    >
      {children}
    </Tooltip>
  );
};

CustomTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  placement: PropTypes.string,
  visible: PropTypes.bool, 
};

export default CustomTooltip;